import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';
import { DecimalPipe } from '@angular/common';
export class TdDigitsPipe implements PipeTransform {
private _decimalPipe: DecimalPipe;
/**
 * @param {?=} _locale
 */
constructor(
private _locale: string = 'en') {
    this._decimalPipe = new DecimalPipe(this._locale);
  }
/**
 * @param {?} digits
 * @param {?=} precision
 * @return {?}
 */
transform(digits: any, precision: number = 1): string {
    if (digits === 0) {
      return '0';
    } else if (isNaN(parseInt(digits, 10))) {
      /* If not a valid number, return the value */
      return digits;
    } else if (digits < 1) {
      return this._decimalPipe.transform(digits.toFixed(precision));
    }
    let /** @type {?} */ k: number = 1000;
    let /** @type {?} */ sizes: string[] = ['', 'K', 'M', 'B', 'T', 'Q'];
    let /** @type {?} */ i: number = Math.floor(Math.log(digits) / Math.log(k));
    let /** @type {?} */ size: string = sizes[i];
    return this._decimalPipe.transform(parseFloat((digits / Math.pow(k, i)).toFixed(precision))) + (size ? ' ' + size : '');
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'digits',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [LOCALE_ID, ] }, ]},
];
}

function TdDigitsPipe_tsickle_Closure_declarations() {
/** @type {?} */
TdDigitsPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdDigitsPipe.ctorParameters;
/** @type {?} */
TdDigitsPipe.prototype._decimalPipe;
/** @type {?} */
TdDigitsPipe.prototype._locale;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
